import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'redux-first-router-link';

import { FormattedNumber, LocaleString } from '@biw/intl';

import { LogoutIcon } from 'components/library';
import CatalogButton from 'shared/shop/catalog-button';

interface Props {
    mediaLabel: string;
    accountBalance: number | null;
    avatarUrl: string;
    userInitials: string;
    logout: () => void;
}

const UserDetails = ( {
    mediaLabel,
    accountBalance,
    avatarUrl,
    userInitials,
    logout,
}: Props ) => (
    <div className="meta">
        <div className="meta-item points">
            <span className="media-label">
                <sub>{mediaLabel}</sub>
            </span>
            <span className="point-value">
                {accountBalance !== null && <FormattedNumber value={accountBalance} />}
            </span>
        </div>
        <div className="meta-item shop">
            <div className="shop-icon client-primary-hover">
                <CatalogButton hideButton showIcon activeClassName="active"/>
            </div>
        </div>
        <div className="meta-item mobile-point-value">
            {accountBalance !== null && <FormattedNumber className="client-primary-bg-color" value={accountBalance} />}
        </div>
        <div className="meta-item profile">
            <NavLink to="/profile" className="profile-link avatar-container">
                <div title={userInitials} className={classNames( { 'avatar': true, 'has-image': !!avatarUrl } )}>
                    { avatarUrl ?
                        <img alt={userInitials} src={avatarUrl} />
                    :
                        <div>
                            <div className="initials client-primary-text">{userInitials}</div>
                            <span aria-hidden="true" className="hidden"><LocaleString code="header.dashboard"/></span>
                        </div>
                    }
                </div>
            </NavLink>
        </div>
        <div className="meta-item logout">
            <a onClick={logout} title="Logout" id="logout" className="logout-link logout client-primary-hover">
                <LogoutIcon />
                <span aria-hidden="true" className="hidden"><LocaleString code="header.logout"/></span>
            </a>
        </div>
    </div>
);

UserDetails.defaultProps = {
    accountBalance: null,
};

export default UserDetails;
